/**
 * @module app.config.general
 */
class Controller {
  /**
   * @param {!app.config.stateservice} appConfigStateService
   * @param {!ui.router.$state} $state
   * @param gettextCatalog
   * @ngInject
   */
  constructor(appConfigStateService, $state, gettextCatalog) {
    /**
     * @export
     * @type {appx.UserSettings}
     */
    this.userSettings;

    /**
     * @export
     * @type {appx.UserSettings}
     */
    this.editUserSettings = {};

    /**
     * @private
     */
    this.configStateService_ = appConfigStateService;

    /**
     * @private
     */
    this.routingState_ = $state;

    this.gettextCatalog = gettextCatalog;
  }

  $onInit() {
    Object.assign(this.editUserSettings, this.userSettings);
  }

  /**
   * @export
   */
  cancel() {
    this.routingState_.go('track-list');
  }

  /**
   * @export
   */
  save() {
    this.configStateService_.saveUserSettings(this.editUserSettings).catch(e => {
      console.error(e);
      bootbox.alert({
        title: this.gettextCatalog.getString('An error occurred'),
        message: this.gettextCatalog.getString('Error when updating configuration')
      });
    });
    this.routingState_.go('track-list');
  }
}

/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'userSettings': '<',
  },
  controller: Controller,
  templateUrl: 'js/app/config/general/partial.html'
};

export default angular.module('appConfigGeneralComponent', [])
  .component('appConfigGeneral', component);
